import { create } from "zustand";

import { authStore } from "./auth-store.ts";
import { currentPageStore } from "./user-page.ts";
import { portalStore } from "./user-portal";
// import { sidebarStore } from './sidebar-store.ts';

const useAuthStore = create(authStore);
// const useSidebarStore = create(sidebarStore)
const usePortalStore = create(portalStore);
const useCurrentPageStore = create(currentPageStore);

export { useAuthStore, useCurrentPageStore, usePortalStore };
